<!-- eslint-disable @typescript-eslint/no-redundant-type-constituents -->
<script setup lang="ts">
type HexColor = string;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const assertHexColor = (value: string): asserts value is HexColor => {
  const hexColorRegex = /^#([0-9a-fA-F]{3}){1,2}$/;
  if (!hexColorRegex.test(value)) {
    throw new Error(`"${value}" is not a valid hexadecimal color code.`);
  }
};

interface Props {
  shadowColor?: HexColor;
  labelColor?:
    | HexColor
    | 'primary'
    | 'secondary'
    | 'accent'
    | 'dark'
    | 'dark-page'
    | 'positive'
    | 'negative'
    | 'info'
    | 'warning'
    | 'main'
    | 'bright';
}

withDefaults(defineProps<Props>(), {
  shadowColor: '#ffffff',
  labelColor: 'light',
});

const model = defineModel<string>();
</script>

<template>
  <q-input
    v-model="model"
    :color="labelColor"
    :label-color="labelColor"
    no-error-icon
    lazy-rules
    class="base-input"
  />
</template>

<style lang="scss">
.base-input {
  box-shadow: 0.5rem 0.5rem 0px 0px v-bind(shadowColor);
  padding-inline: 0.5em;
  padding-block-end: 1.125em;
  border-radius: 1rem;
  height: 5rem;
  font-size: 1.375rem;
  border: 1px solid v-bind(shadowColor);
  & .q-field--standard .q-field__control:before {
    border-bottom: 1px solid rgba(255, 255, 255, 0.24);
  }
  & input {
    color: v-bind(shadowColor);
  }
  & .q-field__control {
    color: v-bind(shadowColor);
  }
  & .q-field__control-container {
    padding-block-start: 0.5em;
  }
}
</style>
